import type { RouteRecordRaw } from 'vue-router'

export const readingsRoutes: RouteRecordRaw[] = [
  {
    path: '/readings',
    name: 'readings',
    component: () => import('./pages/ReadingsPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/readings/:id',
    name: 'reading-detail',
    component: () => import('./pages/ReadingDetailsPage.vue'),
    meta: { requiresAuth: true },
  },
]
